import Atendimento from './Atendimento';

export default Atendimento;